/**
 * Utility functions for handling dynamic localhost port detection
 */
/**
 * Gets the current localhost port from the window location
 * @returns The current port number as a string, or null if not localhost
 */
export const getCurrentLocalhostPort = () => {
    if (typeof window === "undefined") {
        return null;
    }
    const location = window.location;
    // Check if we're running on localhost
    if (location.hostname !== "localhost" && location.hostname !== "127.0.0.1") {
        return null;
    }
    // Return the port if it's one of the valid ports
    const port = location.port;
    if (port === "8080" || port === "8081" || port === "8082") {
        return port;
    }
    return null;
};
/**
 * Checks if the current page is running on localhost with a valid port
 * @returns true if running on localhost with valid port (8080, 8081, or 8082)
 */
export const isValidLocalhost = () => {
    return getCurrentLocalhostPort() !== null;
};
/**
 * Gets the current localhost base URL with the detected port
 * @returns The localhost base URL (e.g., "http://localhost:8081/") or null if not valid localhost
 */
export const getLocalhostBaseURL = () => {
    const port = getCurrentLocalhostPort();
    if (port) {
        return `http://localhost:${port}/`;
    }
    return null;
};
/**
 * Checks if we're running on any localhost port (legacy function for compatibility)
 * @returns true if running on localhost with any valid port
 */
export const isLocalhost = () => {
    return (window.location.href.includes("localhost:8080") ||
        window.location.href.includes("localhost:8081") ||
        window.location.href.includes("localhost:8082"));
};
